import React, { useContext } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Layout from "./components/Layout/Layout";
import { URL } from "./constants";
import NotFound_404 from "./pages/404";
import Home from "./pages/Home";
import Integrations from "./pages/Integrations";
import Search from "./pages/Search";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import { AuthContext } from "./store/auth-context";
import PrivateRoute from "./utils/PrivateRoute";
import SubscriptionDetails from "./pages/SubscriptionDetails";

import "./styles/main.css";
import Conversation from "./pages/Conversation";
import Logout from "./pages/Logout";
import AgentLayout from "./components/Layout/AgentLayout";
import AgentHome from "./pages/agent/Home";
import ToDos from "./pages/agent/ToDos";
import MyConversations from "./pages/agent/MyConversations";
import AgentConversation from "./components/Agent/MyConversations/AgentConversation";
import TenantsList from "./pages/TenantsList";
import TenantSpecificRouting from "./TenantSpecificRouting";
import FreshWorks from "./components/Common/FreshWorks";
import GoogleTagManager from "./components/Common/GoogleTagManager";
import Dashboard from "./pages/Dashboard/Dashboard";
import DashboardContextProvider from "./store/dashboard-context";
import PaginationContextProvider from "./store/pagination-context";

const App = () => {
  const authCtx = useContext(AuthContext);

  return (
    <BrowserRouter>
      {authCtx.isLoggedIn ? <FreshWorks /> : <></>}
      {authCtx.isLoggedIn ? <GoogleTagManager /> : <></>}

      <Routes>
        <Route path={"/"}>
          {/* Sign Up Page */}
          {/* <Route 
						path={URL.signUp}
						element={
							!authCtx.isLoggedIn ? <SignUp /> : <Navigate to={URL.home} />
						} 
					/> */}

          {/* Sign In page */}
          <Route
            path={URL.signIn}
            element={!authCtx.isLoggedIn ? <SignIn /> : <Navigate to={`/`} />}
          />
          {/* Logout page */}
          <Route path={URL.logout} element={<Logout />} />
        </Route>
        <Route path={"/"} element={<Layout showMenus={false} />}>
          <Route
            index
            element={
              !authCtx.currentTenant ? (
                <PrivateRoute>
                  <TenantsList />
                </PrivateRoute>
              ) : (
                <Navigate to={authCtx.currentTenant} />
              )
            }
          />
        </Route>
        {authCtx.currentTenant ? (
          <Route path={`${authCtx.currentTenant}/*`} element={<Layout />}>
            <Route
              index
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path=":uuid"
              element={
                <PrivateRoute>
                  <SubscriptionDetails />
                </PrivateRoute>
              }
            />

            {/* Search Page - Create and Edit Subscription */}
            <Route path={`${URL.search}`}>
              <Route
                index
                element={
                  <PrivateRoute>
                    <Search />
                  </PrivateRoute>
                }
              ></Route>
              <Route
                index={false}
                path=":uuid"
                element={
                  <PrivateRoute>
                    <Search />
                  </PrivateRoute>
                }
              ></Route>
            </Route>

            {/* Conversation Player */}
            <Route
              path={`${URL.conversation}/:id`}
              element={
                <PrivateRoute>
                  <Conversation />
                </PrivateRoute>
              }
            />

            {/* Dashboard Page */}
            <Route
              path={URL.dashboard}
              element={
                <PrivateRoute>
                  <DashboardContextProvider>
                    <PaginationContextProvider>
                      <Dashboard />
                    </PaginationContextProvider>
                  </DashboardContextProvider>
                </PrivateRoute>
              }
            />

            {/* Integrations Page */}
            <Route
              path={URL.integrations}
              element={
                <PrivateRoute>
                  <Integrations />
                </PrivateRoute>
              }
            />

            {/* Agent View */}
            <Route path={URL.agent} element={<AgentLayout />}>
              <Route
                index
                element={
                  <PrivateRoute>
                    <AgentHome />
                  </PrivateRoute>
                }
              ></Route>
              <Route
                path={URL.agentToDos}
                element={
                  <PrivateRoute>
                    <ToDos />
                  </PrivateRoute>
                }
              ></Route>
              <Route path={URL.agentConversations}>
                <Route
                  index={true}
                  element={
                    <PrivateRoute>
                      <MyConversations />
                    </PrivateRoute>
                  }
                ></Route>
                <Route
                  index={false}
                  path=":id"
                  element={
                    <PrivateRoute>
                      <AgentConversation />
                    </PrivateRoute>
                  }
                ></Route>
              </Route>
            </Route>

            <Route path="*" element={<NotFound_404 />} />
          </Route>
        ) : null}
        <Route
          path="*"
          element={
            <PrivateRoute>
              {" "}
              <NotFound_404 />{" "}
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
